<template>
    <div>
        <div class="container">
            <div class="row mt-5 pt-3 mb-3" >
                <div v-b-modal.modalPrevent 
                    class="col-xl-4 col-md-6 mb-4 btn-pointer" 
                    v-for="(d, index) in postsSliced" :key="index" 
                    @click="openPDF(d.acf.ebook)" 
                    v-if="postsSliced"
                >
                    <div class="mb-2 height-257 d-flex justify-content-center align-items-center shadow-video background-image" 
                        :style="`background-image: url(${d.better_featured_image.source_url})`"
                    >
                    </div>
                    <p class="text-center font-glacial-regular font-20">{{d.title.rendered}}</p>
                </div>
                <div class="col-12" v-else>
                    <h2 class="text-center">Nenhum e-book encontrado no momento</h2>
                </div>
                <div class="col-12 text-categories-red text-center font-glacial-bold font-20" v-if="loading">
                    <rotate-square2 class="box-center"></rotate-square2>
                </div>
            </div>
        </div>

        <b-modal hide-footer hide-header centered id="modalPrevent" ref="modal" class="livros-modal-body">
            <div >

                <div class="row justify-content-center pb-4">
                    <div class="col-12">

                        <label class="text-white pt-4">NOME</label>
                        <div class="input-group">
                            <b-form-input v-model="form.nome"
                                        type="text"
                                        placeholder="Nome">
                            </b-form-input>
                            <!-- <div class="text-center height-0">
                                {{showError('nome')}}
                            </div> -->
                        </div>

                        <div class="pt-2">
                            <b-alert show variant="warning mt-3 mt-xl-0" v-if="errors && errors.nome">
                                {{errors.nome[0]}}
                            </b-alert>
                        </div>

                        <label class="text-white pt-4">E-MAIL</label>
                        <div class="input-group">
                            <b-form-input v-model="form.email"
                                        type="text"
                                        placeholder="E-Mail">
                            </b-form-input>
                            <!-- <div class="text-center height-0">
                                {{showError('email')}}
                            </div> -->
                        </div>
                        <div class="pt-2">
                            <b-alert show variant="warning mt-3 mt-xl-0" v-if="errors && errors.email">
                                {{errors.email[0]}}
                            </b-alert>
                        </div>

                        <label class="text-white pt-4">Celular</label>
                        <div class="input-group">
                            <b-form-input v-model="form.whatsapp"
                                        v-mask="'(##) #####-####'"
                                        type="tel"
                                        placeholder="Número Celular">
                            </b-form-input>
                            <!-- <div class="text-center height-0">
                                {{showError('telefone')}}
                            </div> -->
                        </div>
                        <div class="pt-2">
                            <b-alert show variant="warning mt-3 mt-xl-0" v-if="errors && errors.whatsapp">
                                {{errors.whatsapp[0]}}
                            </b-alert>
                        </div>
                    </div>
                </div>

                <div class="row justify-content-center">
                    <div class="col-6">
                        <div class="pt-4 mb-3 input-group">
                            <b-btn class="btn btn-baixar btn-pointer" @click="submit()" :disabled="loading"></b-btn>
                        </div>
                    </div>
                </div>

                <b-alert show variant="success" v-if="success">
                    {{success}}
                </b-alert>
                <!-- <div class="text-center height-0" v-if="showError('nome')">
                    {{showError('nome')}}
                </div>
                <b-alert show variant="warning mt-3 mt-xl-0" v-if="errors">
                    {{errors}}
                </b-alert>
                <div class="text-center height-0" v-if="showError('email')">
                    {{showError('email')}}
                </div> -->
            </div>
        </b-modal>
    </div>
</template>
<script>
import {RotateSquare2} from 'vue-loading-spinner'

export default {
    components: {
        RotateSquare2
    },
    
    props:{
        data: null,
    },

    data(){
        return {
            posts: null,
            page: 0,
            loading: false,
            total: 0,
            indexData: 3,
            loadedId: null,
            errors: null,
            success: null,
            linkPDF: '',
            form: {
                nome: '',
                email: '',
                whatsapp: '',
                id_ebook: '',
                ebook: '',
            },
            link: '',
        }
    },

    created(){
        this.loadMore();
    },

    mounted() {
        var self = this
        window.addEventListener("scroll", function(e){
            var h = document.documentElement,
            b = document.body,
            st = 'scrollTop',
            sh = 'scrollHeight';

            self.scrollPercentage = (h[st]||b[st]) / ((h[sh]||b[sh]) - h.clientHeight) * 100
        
            if(self.scrollPercentage >= 40.00){
                self.indexData += 3
            }
        })
    },

    methods: {
        openPDF(d) {
            this.form.linkPDF = d.url
            this.form.ebook = d.title
            this.form.id_ebook = d.ID
        },
        loadMore(){
            this.page++

            this.loading = true

            var url = window.SETTINGS.API_BASE_PATH + "posts?_embed&categories=3"
            axios.get(url).then(response => {
                this.total = response.headers["x-wp-total"]
                
                this.posts = response.data

                this.loading = false

            })
        },

        async serialize(obj) {
            var str = [];
            for (var p in obj)
                if (obj.hasOwnProperty(p)) {
                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                }
            return str.join("&");
        },

        async submit(pdf, titulo){
            this.loading = true

            // if(this.form.nome == ''){
            //     this.loading = false
            //     return this.errors = 'O nome é obrigatório.';
            // }

            // if(this.form.email == ''){
            //     this.loading = false
            //     return this.errors = 'O e-mail é obrigatório.';
            // }

            // if(this.form.whatsapp == ''){
            //     this.loading = false
            //     return this.errors = 'O número de celular é obrigatório';
            // }

            if(this.success){
                this.loading = false
                return
            } 

            this.loading = true
            this.errors = null

            //Após a verificação se deu retorno 1, ai sim abrir o pdf para ser baixado e não antes.
            
            var query = await this.serialize(this.form);

            var id=365;

            try {

                var response = await axios.get(`http://manager.escolabauhaus.com.br/saveleadebook/?` + query, this.form)
                if(response.data == '1' && response.status == '200'){
                    window.open(this.form.linkPDF, '_blank'); //Abre em um nova página
                    this.form.nome = ''
                    this.form.email = '' 
                    this.form.whatsapp = '' 
                    this.form.ebook = '' 
                    this.form.id_ebook = '' 
                    this.$refs.modal.hide()
                } else {
                    console.log(response.data)
                    this.errors = response.data

                    if(this.errors.nome[0] == ''){
                        this.loading = false
                        return this.errors = this.errors.nome[0];
                    }

                    if(this.errors.email[0] == ''){
                        this.loading = false
                        return this.errors = this.errors.email[0];
                    }

                    if(this.errors.whatsapp[0] == ''){
                        this.loading = false
                        return this.errors = this.errors.whatsapp[0];
                    }
                }
            } catch (e) {
                console.log(e)
            }
            this.loading = false
        },

        showError(field){
            if(this.errors && this.errors.invalidFields){
                for (let index = 0; index < this.errors.invalidFields.length; index++) {
                    const e = this.errors.invalidFields[index];

                    if (e.into.includes(field)){
                        return e.message
                    }
                    
                }
            }

            return null;
        },
    },

    computed:{
        postsSliced(){
            this.loading = true

            if (!this.posts) {
                this.loading = false
                return
            }

            this.loading = false
            
            return this.posts.slice(0, this.indexData)

        },
    }
}
</script>
<style scoped>
.box-center {
    margin: 20px auto;
}
.spinner:after {
    background: #FF0002 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/widgets/ebooks.vue